export default __webpack_public_path__ + "static/media/inscrit-anim.c3aa3f5e.png";